import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
export const QuestionItem = ({ question, quizStatus, onEdit, onDelete, }) => {
    return (React.createElement("div", { className: "question-item__container" },
        React.createElement("div", { className: "question-item__content" },
            React.createElement("div", { className: "question-item__text" },
                React.createElement("h4", null,
                    "Question: ",
                    question.text)),
            React.createElement("div", { className: "question-item__options" },
                React.createElement("div", { className: "question-item__option" },
                    React.createElement("h5", null,
                        "A: ",
                        question.optionA),
                    React.createElement(FontAwesomeIcon, { icon: question.answer === 'A' ? faCircleCheck : faCircle })),
                React.createElement("div", { className: "question-item__option" },
                    React.createElement("h5", null,
                        "B: ",
                        question.optionB),
                    React.createElement(FontAwesomeIcon, { icon: question.answer === 'B' ? faCircleCheck : faCircle })),
                React.createElement("div", { className: "question-item__option" },
                    React.createElement("h5", null,
                        "C: ",
                        question.optionC),
                    React.createElement(FontAwesomeIcon, { icon: question.answer === 'C' ? faCircleCheck : faCircle })),
                React.createElement("div", { className: "question-item__option" },
                    React.createElement("h5", null,
                        "D: ",
                        question.optionD),
                    React.createElement(FontAwesomeIcon, { icon: question.answer === 'D' ? faCircleCheck : faCircle })))),
        React.createElement("div", { className: "question-item__controls" },
            React.createElement("button", { className: "btn--primary", onClick: () => {
                    onEdit(question);
                }, disabled: quizStatus === 'published' }, "Edit"),
            React.createElement("button", { className: "btn--delete", onClick: () => {
                    onDelete(question);
                }, disabled: quizStatus === 'published' }, "Delete"))));
};
